import React, { useState } from 'react';
import { Container, Typography, Box, TextField, Button, Grid, Paper, Alert, CircularProgress } from '@mui/material';
import { publicService } from '../../services/api';

const Contact = () => {
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [status, setStatus] = useState({ loading: false, success: '', error: '' });

  const handleChange = (field, value) => {
    setForm(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ loading: true, success: '', error: '' });
    try {
      await publicService.submitContact(form);
      setStatus({ loading: false, success: 'Message sent successfully. We will reply soon.', error: '' });
      setForm({ name: '', email: '', subject: '', message: '' });
    } catch (err) {
      console.error(err);
      setStatus({ loading: false, success: '', error: err.response?.data?.error || 'Failed to send message' });
    }
  };

  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Typography variant="h3" gutterBottom fontWeight={700}>Contact Us</Typography>
      <Typography variant="subtitle1" color="text.secondary" paragraph>
        Have a question about an order, customization, or partnership? Reach out—we'll respond as soon as possible.
      </Typography>

      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 3 }} elevation={2}>
            <Typography variant="h6" gutterBottom>Send a Message</Typography>
            {status.success && <Alert severity="success" sx={{ mb: 2 }}>{status.success}</Alert>}
            {status.error && <Alert severity="error" sx={{ mb: 2 }}>{status.error}</Alert>}
            <Box component="form" onSubmit={handleSubmit}>
              <TextField fullWidth label="Name" required margin="normal" value={form.name} onChange={(e)=>handleChange('name', e.target.value)} />
              <TextField fullWidth label="Email" type="email" required margin="normal" value={form.email} onChange={(e)=>handleChange('email', e.target.value)} />
              <TextField fullWidth label="Subject" margin="normal" value={form.subject} onChange={(e)=>handleChange('subject', e.target.value)} />
              <TextField fullWidth label="Message" required margin="normal" multiline rows={4} value={form.message} onChange={(e)=>handleChange('message', e.target.value)} />
              <Button type="submit" variant="contained" sx={{ mt: 2 }} disabled={status.loading}>
                {status.loading ? <CircularProgress size={20} /> : 'Submit'}
              </Button>
            </Box>
          </Paper>
        </Grid>
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 3 }} elevation={2}>
            <Typography variant="h6" gutterBottom>Other Ways</Typography>
            <Typography variant="body2" color="text.secondary" paragraph>Email: info@therandomstore.com</Typography>
            <Typography variant="body2" color="text.secondary" paragraph>Working Hours: Mon - Sat / 10 AM - 6 PM</Typography>
            <Typography variant="body2" color="text.secondary" paragraph>We usually respond within 24 hours.</Typography>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Contact;
